/**
 * Label Component
 * Form label with required indicator
 * WCAG 2.1 AA compliant
 */

import React from 'react';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  children: React.ReactNode;
}

export const Label: React.FC<LabelProps> = ({
  required = false,
  children,
  className = '',
  ...props
}) => {
  return (
    <label className={`block text-sm font-medium text-neutral-700 ${className}`} {...props}>
      {children}
      {required && (
        <span className="text-error-600 ml-1" aria-label="required">
          *
        </span>
      )}
    </label>
  );
};
